import { Minus, Plus } from 'lucide-react';
import { MAX_DISPLAY_DEPTH, MIN_DISPLAY_DEPTH } from './crawlUrlTreeHelpers';
import './CrawlUrlTree.css';

type CrawlUrlDepthStepperProps = {
  value: number;
  onChange: (value: number) => void;
  ariaLabel: string;
  decreaseLabel: string;
  increaseLabel: string;
  disabled?: boolean;
};

export function CrawlUrlDepthStepper({
  value,
  onChange,
  ariaLabel,
  decreaseLabel,
  increaseLabel,
  disabled = false,
}: CrawlUrlDepthStepperProps) {
  return (
    <div
      className="crawl-url-tree__stepper"
      role="group"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className="crawl-url-tree__stepper-button"
        aria-label={decreaseLabel}
        disabled={disabled || value <= MIN_DISPLAY_DEPTH}
        onClick={() => onChange(Math.max(MIN_DISPLAY_DEPTH, value - 1))}
      >
        <Minus aria-hidden />
      </button>
      <span className="crawl-url-tree__stepper-value" aria-live="polite">
        {value}
      </span>
      <button
        type="button"
        className="crawl-url-tree__stepper-button"
        aria-label={increaseLabel}
        disabled={disabled || value >= MAX_DISPLAY_DEPTH}
        onClick={() => onChange(Math.min(MAX_DISPLAY_DEPTH, value + 1))}
      >
        <Plus aria-hidden />
      </button>
    </div>
  );
}
